/* LE BADGE « RECOMMANDE » SUR LA MOULURE QUI VA LE MIEUX A L'AFFICHE.
 *
 * ⛔ LA DECISION EST PRISE EN LIQUID, PAS ICI. `pdp-cadre-conseil.liquid` lit les tags de
 * couleur de l'affiche et rend un RANG : 0 blanc, 1 noir, 2 chene clair. Ce fichier ne fait que
 * poser le badge. Deux endroits qui decideraient finiraient par se contredire, et c'est le genre
 * de contradiction qu'on ne voit pas : les deux affichent quelque chose.
 *
 * ⛔ LE RANG, JAMAIS LE NOM. Les valeurs d'option sont traduites par Markets : « Chene clair »
 * s'appelle autrement sur /nl, et product.js lit deja ces trois couleurs par leur position pour
 * cette raison exacte.
 *
 * ⚠️ LES PASTILLES N'EXISTENT PAS AU CHARGEMENT. Le bloc du cadre est construit apres le choix
 * d'une taille : on observe donc, plutot que de poser une fois et d'echouer en silence.
 */
(function () {
  'use strict';
  var rang = window.__pdpCadreConseil;
  var mot = window.__pdpCadreConseilMot || '';
  if (rang === undefined || rang === null || !mot) return;

  function poser() {
    var bloc = document.getElementById('pdp-up-frame');
    if (!bloc) return false;
    var pastilles = bloc.querySelectorAll('.pdp-up-color');
    if (pastilles.length < 3) return false;
    var cible = pastilles[rang];
    if (!cible || cible.dataset.conseil === '1') return true;
    /* ⛔ UNE PASTILLE SANS BOITE MESURE ZERO, ET CE ZERO SE CALCULE SANS LEVER D'ERREUR. Le bloc
     * du cadre existe dans le DOM avant d'etre montre : les trois pastilles s'y trouvaient deja,
     * larges de 0, et le badge se posait a `left:0`, soit 133 px a gauche de sa cible. On attend
     * qu'elles aient une largeur, l'observateur rappellera. */
    if (!cible.getBoundingClientRect().width) return false;
    cible.dataset.conseil = '1';
    /* ⚠️ LE BADGE EST POSE SUR LE PARENT, PAS DANS LE BOUTON. La pastille porte sa photo de
       moulure en fond : un enfant ajoute dedans se poserait par-dessus le bois. */
    var hote = cible.parentNode;
    if (!hote) return true;
    if (getComputedStyle(hote).position === 'static') hote.style.position = 'relative';
    var b = document.createElement('span');
    b.className = 'pdp-up-conseil';
    b.textContent = mot;
    /* Le badge est decoratif pour un lecteur d'ecran : l'information utile est deja dans le
       `aria-label` de la pastille, qu'on complete plutot que de la doubler. */
    b.setAttribute('aria-hidden', 'true');
    var lab = cible.getAttribute('aria-label') || '';
    if (lab) cible.setAttribute('aria-label', lab + ' — ' + mot);
    hote.appendChild(b);
    /* ⛔ ON MESURE LES DEUX BOITES, ON NE LIT PAS `offsetLeft`. Premier jet : le badge se posait
     * a gauche du bloc, tronque. `offsetLeft` est compte depuis l'`offsetParent`, qui n'est pas
     * forcement le parent ou l'on vient d'ajouter le badge : ici c'etait un conteneur plus haut,
     * et l'ecart valait la largeur de toute la colonne. La difference des deux rectangles, elle,
     * ne depend d'aucune supposition. */
    /* ⛔ ET LE HAUT SE MESURE PAREIL, POUR LA MEME RAISON (Adrien, 19/08/2026 : « recommande
     * trop bas »). Il etait pose en CSS a `top:100%`, donc au bas du CONTENEUR et non de la
     * pastille. Or ce conteneur porte un rembourrage bas, celui-la meme que j'avais ajoute pour
     * reserver la place du badge : chaque pixel reserve eloignait le badge d'autant. Une
     * correction qui se defait elle-meme, et qui grandit avec la place qu'on lui donne.
     * ⚠️ L'ECART VIT ICI ET NULLE PART AILLEURS : un `margin-top` en CSS s'ajouterait a ce
     * calcul, et l'ecart reel serait la somme de deux valeurs ecrites a deux endroits. */
    var r = cible.getBoundingClientRect();
    var rh = hote.getBoundingClientRect();
    /* ⚠️ ET IL RESTE DANS LA COLONNE. Le badge est plus large qu'une pastille (76 px contre 46) :
     * centre sous la premiere, il sortait de 15 px a gauche, donc a gauche du texte aligne juste
     * en dessous. Vu a l'oeil le 19/08/2026, sur un produit de rang 0. On le ramene au bord : il
     * cesse d'etre exactement centre, mais il designe toujours la meme pastille, et une mention
     * qui deborde de sa colonne se lit comme un defaut. */
    var demi = b.getBoundingClientRect().width / 2;
    var x = r.left - rh.left + r.width / 2;
    if (demi > 0) {
      if (x < demi) x = demi;
      else if (x > rh.width - demi) x = rh.width - demi;
    }
    b.style.left = x + 'px';
    b.style.top = (r.bottom - rh.top + 6) + 'px';
    return true;
  }

  if (poser()) return;
  var mo = new MutationObserver(function () { if (poser()) mo.disconnect(); });
  mo.observe(document.body, { childList: true, subtree: true });
  /* Au bout d'une minute, la taille n'a pas ete choisie : rien a poser, et un observateur qui
     vit toute la session pour rien coute a chaque frappe dans la page. */
  setTimeout(function () { mo.disconnect(); }, 60000);
})();
